import { render, staticRenderFns } from "./AdminInterventi.vue?vue&type=template&id=f35a9c42&scoped=true"
import script from "./AdminInterventi.vue?vue&type=script&lang=js"
export * from "./AdminInterventi.vue?vue&type=script&lang=js"
import style0 from "./AdminInterventi.vue?vue&type=style&index=0&id=f35a9c42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f35a9c42",
  null
  
)

export default component.exports